module.exports = __webpack_public_path__ + "img/video_placeholder.1ecf3e67.jpg";